import { sizing, ToastNotifications } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import styled from 'styled-components';

import { SubjectRequirementsContainer } from './components';
import { setInternal } from './redux/internal.slice';
import { setupStore } from './redux/store';

function SubjectRequirements(props) {
  const { account, token } = props;

  // Store
  const [store] = useState(setupStore());

  // Effects
  useEffect(() => {
    const internalValues = {
      authenticityToken: token,
      accountId: account.id,
    };

    store.dispatch(setInternal(internalValues));
  }, []);

  return (
    <Provider store={store}>
      <ToastNotifications />
      <Wrapper>
        <SubjectRequirementsContainer />
      </Wrapper>
    </Provider>
  );
}

const Wrapper = styled.div`
  padding: ${sizing.large};
`;

SubjectRequirements.propTypes = {
  account: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  token: PropTypes.string.isRequired,
};

export default SubjectRequirements;
